import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import TableContainer from 'components/Common/TableContainer'
import {
    Card,
    CardBody,
    Button,
    Container,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input
} from 'reactstrap'
import {
    approveVehicleSuggetion,
    rejectVehicleSuggestion,
    sendSuggestionEmail,
    viewVehicleSuggestions,
    changeAction, // ⬅️ NEW
} from 'store/actions';
import { SrNo, VehicleMake, VehicleModel, Notes, Status, CreatedBy, CreatedAt } from './VehicleMasterCol'
import Spinners from 'components/Common/Spinner'
import { createSelector } from 'reselect'
import { toast } from 'react-toastify'
import AddNewVehicleModal from './AddNewVehicleModal'

const VehicleMasterAdmin = () => {
    const dispatch = useDispatch();
    const [modal, setModal] = useState({
        isShow: false,
        type: 1, // 1 for Approve & 0 For Delete req
    })

    const [selectedVehicle, setSelectedVehicle] = useState(null);

    const [showAddVehicleModal, setShowAddVehicleModal] = useState(false)

    const [sendMailModal, setSendMailModal] = useState({
        showModal: false,
        suggestionStatus: "",
        suggestionId: ""
    })

    // ⬇️ NEW: modal for changing action in DB
    const [changeActionModal, setChangeActionModal] = useState({
        showModal: false,
        action: "",
        suggestionId: ""
    })

    const sendSuggetionStatus = () => {
        dispatch(sendSuggestionEmail({ id: sendMailModal.suggestionId, action: sendMailModal.suggestionStatus }))
        closeSendMailModal();
    }

    const viewSendMailModal = (suggestionId) => {
        setSendMailModal({
            showModal: true,
            suggestionStatus: "",
            suggestionId: suggestionId
        })
    }

    const closeSendMailModal = () => {
        setSendMailModal({
            showModal: false,
            suggestionStatus: "",
            suggestionId: ""
        })
    }

    // ⬇️ NEW: open/close handlers for Change Action Modal
    const openChangeActionModal = (vehicle) => {
        setChangeActionModal({
            showModal: true,
            action: vehicle.action && vehicle.action !== "" ? vehicle.action : "",
            suggestionId: vehicle.id
        })
    }

    const closeChangeActionModal = () => {
        setChangeActionModal({
            showModal: false,
            action: "",
            suggestionId: ""
        })
    }

    const handleChangeActionSubmit = () => {
        if (!changeActionModal.action) {
            toast.error("Please select action");
            return;
        }

        dispatch(
            changeAction({
                id: changeActionModal.suggestionId,
                action: changeActionModal.action,
            })
        );

        closeChangeActionModal();
    }

    const handleClickAccept = (vehicle) => {
        setSelectedVehicle(vehicle);
        setModal({ ...modal, isShow: true, type: 1 })
    }

    const handleClickRemove = (vehicle) => {
        setSelectedVehicle(vehicle);
        setModal({ ...modal, isShow: true, type: 0 })
    }

    const handleCloseModal = () => {
        setSelectedVehicle(null);
        setModal({ ...modal, isShow: false, type: 1 })
    }

    const handleApproveVehicleSuggetion = () => {
        dispatch(approveVehicleSuggetion({
            brand_name: selectedVehicle.vehicle_make,
            model_name: selectedVehicle.vehicle_model,
            suggestion_id: selectedVehicle.id
        }))
        setModal({
            ...modal,
            isShow: false,
            type: 1
        })
    }

    const handleRejectVehicleSuggetion = () => {
        dispatch(rejectVehicleSuggestion({ id: selectedVehicle.id }))
        setModal({
            ...modal,
            isShow: false,
            type: 1
        })
    }

    // Getting Redux State
    const VehicleMasterReducer = state => state.VehicleMasterReducer
    const VehicleMasterProperty = createSelector(
        VehicleMasterReducer,
        VehicleMasterStore => ({
            errors: VehicleMasterStore.errors,
            successMsg: VehicleMasterStore.successMsg,
            Loading: VehicleMasterStore.Loading,
            suggestionList: VehicleMasterStore.suggestionList
        })
    )

    const { errors, successMsg, Loading, suggestionList } =
        useSelector(VehicleMasterProperty)

    useEffect(() => {
        if (errors && errors !== "") {
            toast.error(errors)
        }
        if (successMsg && successMsg !== "") {
            toast.success(successMsg)
            dispatch(viewVehicleSuggestions())
        }
    }, [errors, successMsg, dispatch])

    useEffect(() => {
        dispatch(viewVehicleSuggestions())
    }, [dispatch])


    const columns = useMemo(
        () => [
            {
                Header: "Sr No",
                accessor: (row, i) => i + 1,
                filterable: true,
                Cell: cellProps => {
                    return <SrNo {...cellProps} />
                },
            },
            {
                Header: "Vehicle Make",
                accessor: "vehicle_make",
                filterable: true,
                Cell: cellProps => {
                    return <VehicleMake {...cellProps} />
                },
            },
            {
                Header: "Vehicle Model",
                accessor: "vehicle_model",
                filterable: true,
                Cell: cellProps => {
                    return <VehicleModel {...cellProps} />
                },
            },

            {
                Header: "Notes",
                accessor: "notes",
                filterable: true,
                Cell: cellProps => {
                    return <Notes {...cellProps} />
                },
            },

            {
                Header: "Status",
                accessor: "action",
                filterable: true,
                Cell: cellProps => {
                    return <Status {...cellProps} />
                },
            },
            {
                Header: "Created By",
                accessor: "name",
                filterable: true,
                Cell: cellProps => {
                    return <CreatedBy {...cellProps} />
                }
            },
            {
                Header: "Created At",
                accessor: "createdAt",
                filterable: true,
                Cell: cellProps => {
                    return <CreatedAt {...cellProps} />
                }
            },
            {
                Header: "Action",
                accessor: "performAction",
                disableFilters: true,
                Cell: cellProps => {
                    const rowData = cellProps.row.original;

                    return (
                        <ul className="list-unstyled hstack gap-2 mb-0">
                            {/* Email Suggestion Status - always visible */}
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => viewSendMailModal(rowData.id)}
                                    id={`emailsuggestion-${rowData.id}`}
                                >
                                    <i className="mdi mdi-email-send-outline" />
                                    <UncontrolledTooltip
                                        placement="top"
                                        target={`emailsuggestion-${rowData.id}`}
                                    >
                                        EmailSuggestion Status
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            {/* Edit Action - always visible, even when Pending */}
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-warning"
                                    onClick={() => openChangeActionModal(rowData)}
                                    id={`editaction-${rowData.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip
                                        placement="top"
                                        target={`editaction-${rowData.id}`}
                                    >
                                        Edit Action
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            {/* Approve / Reject - only when Pending */}
                            {rowData.action === "Pending" && (
                                <>
                                    <li
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id={`approvetooltip-${rowData.id}`}
                                        className="btn btn-sm btn-soft-info"
                                        onClick={() => handleClickAccept(rowData)}
                                    >
                                        <i className="mdi mdi-checkbox-marked-circle-outline"></i>
                                        <UncontrolledTooltip
                                            placement="top"
                                            target={`approvetooltip-${rowData.id}`}
                                        >
                                            Approve Suggestion
                                        </UncontrolledTooltip>
                                    </li>

                                    <li>
                                        <Link
                                            to="#"
                                            className="btn btn-sm btn-soft-danger"
                                            onClick={() => handleClickRemove(rowData)}
                                            id={`rejecttooltip-${rowData.id}`}
                                        >
                                            <i className="mdi mdi-close-circle-outline" />
                                            <UncontrolledTooltip
                                                placement="top"
                                                target={`rejecttooltip-${rowData.id}`}
                                            >
                                                Reject Suggestion
                                            </UncontrolledTooltip>
                                        </Link>
                                    </li>
                                </>
                            )}
                        </ul>
                    );
                },
            }
        ], [])

    return (
        <div className='page-content'>
            <Container fluid={true}>
                {
                    Loading ? <Spinners /> :
                        <Card>
                            <CardBody>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <p className='mt-2 fs-4'>Vehicle Master</p>

                                    <Button color='primary' onClick={() => setShowAddVehicleModal(true)}> Add New Vehicle</Button>
                                </div>

                                <div>
                                    <TableContainer
                                        columns={columns}
                                        data={suggestionList}
                                        isGlobalFilter={true}
                                        isAddOptions={false}
                                        isJobListGlobalFilter={false}
                                        isPagination={true}
                                        iscustomPageSizeOptions={true}
                                        isShowingPageLength={true}
                                        customPageSize={15}
                                        tableClass="table-bordered align-middle nowrap mt-2"
                                        paginationDiv="col-sm-12 col-md-7"
                                        pagination="pagination justify-content-end pagination-rounded"
                                    />
                                </div>
                            </CardBody>
                        </Card>
                }

                {/* Confirm Approve / Reject Modal */}
                <Modal isOpen={modal.isShow} toggle={handleCloseModal}>
                    <ModalHeader toggle={handleCloseModal} tag={"h4"}>
                        <p>Are You Sure ?</p>
                    </ModalHeader>
                    <ModalBody>
                        <p className='fs-3'>{modal.type === 0 ? "Do you want reject request" : "Do you want Approve request"}</p>
                        <ul>
                            <li>Vehicle Brand : <b>{selectedVehicle && selectedVehicle.vehicle_make || ""}</b></li>
                            <li>Vehicle Model : <b>{selectedVehicle && selectedVehicle.vehicle_model || ""}</b></li>
                        </ul>
                        <div className='d-flex justify-content-between'>
                            {
                                modal.type === 0 ?
                                    <Button color='danger' onClick={handleRejectVehicleSuggetion}>DELETE</Button>
                                    :
                                    <Button color='success' onClick={handleApproveVehicleSuggetion}>APPROVE</Button>
                            }
                            <Button color='primary' onClick={handleCloseModal}>CANCEL</Button>
                        </div>
                    </ModalBody>
                </Modal>

                {/* Send Status Mail Modal */}
                <Modal isOpen={sendMailModal.showModal} toggle={closeSendMailModal}>
                    <ModalHeader toggle={closeSendMailModal} tag={"h4"}>
                        <p>SEND STATUS MAIL</p>
                    </ModalHeader>
                    <ModalBody>
                        <Input
                            type='select'
                            value={sendMailModal.suggestionStatus}
                            onChange={(e) => setSendMailModal({
                                ...sendMailModal,
                                suggestionStatus: e.target.value
                            })}
                        >
                            <option value={""}>SELECT STATUS</option>
                            <option value={"Done"}>Done</option>
                            <option value={"Rejected"}>Rejected</option>
                            <option value={"Pending"}>Pending</option>
                        </Input>
                    </ModalBody>
                    <ModalFooter>
                        <div className='d-flex justify-content-between w-100'>
                            <Button color='primary' onClick={sendSuggetionStatus}>SUBMIT</Button>
                            <Button color='danger' onClick={closeSendMailModal}>CANCEL</Button>
                        </div>
                    </ModalFooter>
                </Modal>

                {/* ⬇️ NEW: Change Action Modal */}
                <Modal isOpen={changeActionModal.showModal} toggle={closeChangeActionModal}>
                    <ModalHeader toggle={closeChangeActionModal} tag={"h4"}>
                        <p>CHANGE ACTION</p>
                    </ModalHeader>
                    <ModalBody>
                        <Input
                            type='select'
                            value={changeActionModal.action}
                            onChange={(e) =>
                                setChangeActionModal({
                                    ...changeActionModal,
                                    action: e.target.value
                                })
                            }
                        >
                            <option value={""}>SELECT ACTION</option>
                            <option value={"Done"}>Done</option>
                            <option value={"Rejected"}>Rejected</option>
                        </Input>
                    </ModalBody>
                    <ModalFooter>
                        <div className='d-flex justify-content-between w-100'>
                            <Button color='primary' onClick={handleChangeActionSubmit}>SUBMIT</Button>
                            <Button color='danger' onClick={closeChangeActionModal}>CANCEL</Button>
                        </div>
                    </ModalFooter>
                </Modal>

                <AddNewVehicleModal showModal={showAddVehicleModal} setShowModal={setShowAddVehicleModal} />
            </Container>

        </div>
    )
}

export default VehicleMasterAdmin
